import React from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { ApolloProvider } from '@apollo/client';
import CssBaseline from '@material-ui/core/CssBaseline';
import { withStyles } from '@material-ui/core/styles';

import { createStore, StoreProvider } from '../store';
import { apolloClient } from '../apollo-client';
import { FeatureFlagProvider } from '../feature-flags';
import { StaffSpeedDial } from './speed-dial';
import { StaffToolsChat } from './staff-tools-chat';
import { AppcuesLaunchpadDrag } from './appcues-launchpad-drag';
import Auth from './auth';
import ErrorBoundary from './error-boundary';
import Layout from './layout/layout';
import Routes from './routes';
import { ViewAsProvider } from './view-as';
import ThemeProvider from './theme';
import { colors, fonts } from './theme/variables';
import { Toast, ToastProvider } from './toast';
import { StaffToolsPreviewBoundary } from 'tools/contextual-prototype/staff-preview';

const rootStyles = {
  '@global': {
    '*': {
      fontFamily: fonts.LibreFranklin
    },
    body: {
      backgroundColor: colors.page__background_primary
    },
    ':focus': {
      outline: 'none'
    },
    '::-moz-focus-inner': {
      border: 0
    },
    a: {
      textDecoration: 'none',
      display: 'contents' // https://drafts.csswg.org/css-display/#valdef-display-contents
    }
  }
};

const store = createStore(apolloClient);
const App = () => {
  return (
    <ThemeProvider>
      <ErrorBoundary>
        <StoreProvider store={store}>
          <ToastProvider>
            <Auth client={apolloClient}>
              <FeatureFlagProvider>
                <ApolloProvider client={apolloClient}>
                  {/* Inside the feature-flag provider so flags are fetched for the real user, never the lens */}
                  <ViewAsProvider>
                    <CssBaseline />

                    <Router basename="/">
                      <StaffToolsPreviewBoundary>
                        <Layout>
                          <Routes />
                        </Layout>
                        <StaffSpeedDial quotePage={false} />
                        <StaffToolsChat />
                        <AppcuesLaunchpadDrag />
                      </StaffToolsPreviewBoundary>
                    </Router>
                    <Toast />
                  </ViewAsProvider>
                </ApolloProvider>
              </FeatureFlagProvider>
            </Auth>
          </ToastProvider>
        </StoreProvider>
      </ErrorBoundary>
    </ThemeProvider>
  );
};

export default withStyles(rootStyles)(App);
